import { createContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Layout from '@components/layout';

interface LayoutContextType {
  showContactUs: boolean;
}

/**
 * @see {@link Layout} to get to the Provider (of this context)
 */
const LayoutContext = createContext<LayoutContextType>({ showContactUs: false });

export default LayoutContext;
